module.exports = __webpack_public_path__ + "static/img/wechat_company.8021e55b.png";